import type { PairingPayload } from "../pairings";

/** The pairing manager: add a pairing by key, list/remove pairings, mirror from phone, enable notifications. */
export function PairPanel({
  pairInput,
  setPairInput,
  onAddPair,
  pairings,
  onRemovePair,
  onMirror,
  onEnableNotifications,
}: {
  pairInput: string;
  setPairInput: (v: string) => void;
  onAddPair: () => void;
  pairings: PairingPayload[];
  onRemovePair: (id: string) => void;
  onMirror: () => void;
  onEnableNotifications: () => void;
}) {
  return (
    <div className="pair-panel">
      <div className="composer">
        <input
          value={pairInput}
          onChange={(e) => setPairInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onAddPair()}
          placeholder="cc1:… (add another pairing)"
        />
        <button onClick={onAddPair}>Pair</button>
      </div>
      <div className="pair-list">
        {pairings.map((p) => (
          <div key={p.pairingId} className="pair-item">
            <span className="label">{p.name || p.pairingId}</span>
            <button className="remove" onClick={() => onRemovePair(p.pairingId)}>
              Remove
            </button>
          </div>
        ))}
      </div>
      <button className="linkish" style={{ margin: "0 6px 8px" }} onClick={onMirror}>
        Mirror all from phone…
      </button>
      <button className="linkish" style={{ margin: "0 6px 8px" }} onClick={onEnableNotifications}>
        Enable notifications
      </button>
    </div>
  );
}
